package org.matthewo.symbolprocessor

enum class Period {
    ALL,
    AUTO,
    TELEOP,
    ENDGAME
}

annotation class Metric(val period: Period, val name: String, val longName: String = "", val pointValue: Double = Double.NaN)
